import * as React from 'react';
import styled from 'styled-components';

import { Slot } from './Slot';

const StyledSpan = styled.span`
  position: absolute;
  border: 0;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  word-wrap: normal;
`;

const visuallyHiddenStyle: React.CSSProperties = {
  position: 'absolute',
  border: 0,
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  wordWrap: 'normal',
};

export interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLSpanElement> {
  asChild?: boolean;
  children: React.ReactNode;
}

export const VisuallyHidden: React.FC<VisuallyHiddenProps> = ({ asChild, children, style, ...rest }) => {
  if (asChild) {
    return (
      <Slot {...(rest as React.HTMLAttributes<HTMLElement>)} style={{ ...visuallyHiddenStyle, ...style }}>
        {children}
      </Slot>
    );
  }

  return (
    <StyledSpan {...rest} style={style}>
      {children}
    </StyledSpan>
  );
};

VisuallyHidden.displayName = 'VisuallyHidden';
